import React from 'react';
import { FaApple, FaGithub, FaGoogle, FaWindows } from 'react-icons/fa';
import { OAUTH_CONNECTIONS } from '../utils/authConfig';

const OAUTH_PROVIDERS = [
  { key: 'google', label: 'Google', icon: FaGoogle, connection: OAUTH_CONNECTIONS.GOOGLE },
  { key: 'github', label: 'GitHub', icon: FaGithub, connection: OAUTH_CONNECTIONS.GITHUB },
  { key: 'apple', label: 'Apple', icon: FaApple, connection: OAUTH_CONNECTIONS.APPLE },
  { key: 'microsoft', label: 'Microsoft', icon: FaWindows, connection: OAUTH_CONNECTIONS.MICROSOFT }
];

function OAuthLoginButtons({ onOAuthLogin, loading, styles, mutedColor }) {
  const enabledProviders = OAUTH_PROVIDERS.filter((provider) => provider.connection);
  if (!enabledProviders.length) return null;

  return (
    <div style={styles.oauthGrid}>
      {enabledProviders.map((provider) => {
        const ProviderIcon = provider.icon;
        return (
          <button
            key={provider.key}
            type="button"
            style={styles.oauthBtn}
            onClick={() => onOAuthLogin(provider.connection)}
            disabled={loading}
          >
            <span style={styles.oauthBtnContent}>
              <span style={styles.oauthIconWrap}>
                <ProviderIcon size={14} aria-hidden="true" />
              </span>
              <span>{`Log in with ${provider.label}`}</span>
            </span>
            <span style={{ color: mutedColor }}>→</span>
          </button>
        );
      })}
    </div>
  );
}

export default OAuthLoginButtons;
